import { leadConnectionsApi } from './api';

export const useLeadConnections = (leadId: number) => {
  const { data, isLoading, error } = leadConnectionsApi.useGetLeadContactQuery({ leadId }, { refetchOnMountOrArgChange: true });
  return { companies: data, isLoading, error };
};
